export const getImagePath = (image) => {
  if (!image || !image.url) {
    return '';
  }

  const hasAbsolutePath = `${image?.url || ''}`.startsWith('http');

  return `${!hasAbsolutePath ? process.env.NEXT_PUBLIC_CDN_URL : ''}${image?.url}?published-at=${image?.publishedAt}`;
};
